import { z } from 'zod';

import { chatUiBase } from '../../shared/schema/base.js';

/** O glifo de cada resposta: o serviço que ela leva, ou o genérico. */
export const CONFIRM_PROMPT_GLYPHS = ['flight', 'hotel', 'rental', 'bus', 'generic'] as const;
export type ConfirmPromptGlyph = (typeof CONFIRM_PROMPT_GLYPHS)[number];
const hint = z.string().min(1).max(120).optional();
const glyph = z.enum(CONFIRM_PROMPT_GLYPHS).optional();

/**
 * `confirm_prompt` — prompt de confirmação GENÉRICO no corpo do turno (slot
 * `chat`): a pergunta é o texto do turno, e aqui ficam só as duas respostas
 * (confirmar/manter), resolvidas ESTRUTURALMENTE via challengeId, nunca por prosa
 * interpretada pelo LLM. `message` é o rótulo acessível do grupo. Toda a copy
 * (mensagem, rótulos e apoios) chega LOCALIZADA do servidor (strings.ts do domínio
 * emissor) — o card não tem copy própria, de propósito: é reusável por qualquer
 * domínio/ação destrutiva.
 */
export const ConfirmPromptBlockSchema = z
  .object({
    ...chatUiBase,
    kind: z.literal('confirm_prompt'),
    challengeId: z.string().min(1),
    message: z.string().min(1).max(280),
    confirmLabel: z.string().min(1).max(60),
    denyLabel: z.string().min(1).max(60),
    confirmHint: hint,
    denyHint: hint,
    confirmGlyph: glyph,
    denyGlyph: glyph,
  })
  .strict();
export type ConfirmPromptBlock = z.infer<typeof ConfirmPromptBlockSchema>;

/**
 * Payload ecoado em `confirmation.selections` — `confirm` executa a ação
 * (descartar/recomeçar), `deny` mantém o fluxo atual. Estrito, com `action`
 * fechado em enum — os literais não colidem com as selections discriminadas
 * dos outros cards.
 */
export const ConfirmPromptSelectionSchema = z
  .object({ action: z.enum(['confirm', 'deny']) })
  .strict();
export type ConfirmPromptSelection = z.infer<typeof ConfirmPromptSelectionSchema>;
